import { render, staticRenderFns } from "./BannerManager.vue?vue&type=template&id=3f7b5d50&scoped=true"
import script from "./BannerManager.vue?vue&type=script&lang=js"
export * from "./BannerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b5d50",
  null
  
)

export default component.exports